(function () {
  'use strict';

  // Aktiver/deaktiver checkout-knappen ud fra om checkboxen er afkrydset
  function sync() {
    var agree = document.getElementById('agree');
    var btn = document.getElementById('CartDrawer-Checkout');
    if (!agree || !btn) return;

    var ok = agree.checked;
    btn.disabled = !ok;

    // Skjul fejlbesked når der er sat flueben
    var alert = document.querySelector('.red-alert');
    if (alert && ok) alert.classList.add('d-none');
  }

  // Vis fejlbesked hvis man forsøger uden flueben
  function guard(e) {
    var agree = document.getElementById('agree');
    if (agree && !agree.checked) {
      e.preventDefault();
      e.stopPropagation();
      var alert = document.querySelector('.red-alert');
      if (alert) alert.classList.remove('d-none');
      agree.focus();
      return false;
    }
  }

  // Event-delegation -> virker også når cart drawer gen-renderes
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'agree') sync();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (btn) guard(e);
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'CartDrawer-Form') guard(e);
  }, true);

  // Kør ved load og når DOM ændrer sig (drawer åbner/opdateres)
  document.addEventListener('DOMContentLoaded', sync);
  new MutationObserver(sync).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  sync();
})();